// RosterImport.js
import React from 'react';
import { Button } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const RosterImport = ({ rosterId, handleFileUpload, fileInputKey }) => {
    return (
        <Button
            component="label"
            variant="outlined"
            startIcon={<CloudUploadIcon />}
            sx={{ mb: 2 }}
            fullWidth
        >
            Import Students
            <input
                key={`${fileInputKey}-${rosterId}`}
                type="file"
                accept=".txt,.csv"
                hidden
                onChange={(e) => handleFileUpload(rosterId, e)}
            />
        </Button>
    );
};

export default RosterImport;